export const auctionConstants = {
  AUCTIONS_GET_REQUEST: "AUCTIONS_GET_REQUEST",
  AUCTIONS_GET_SUCCESS: "AUCTIONS_GET_SUCCESS",
  AUCTIONS_GET_FAILURE: "AUCTIONS_GET_FAILURE",

  AUCTIONS_UPDATE_REQUEST: "AUCTIONS_UPDATE_REQUEST",
  AUCTIONS_UPDATE_SUCCESS: "AUCTIONS_UPDATE_SUCCESS",
  AUCTIONS_UPDATE_FAILURE: "AUCTIONS_UPDATE_FAILURE"
};
